import { Controller } from "@hotwired/stimulus"

// Sincroniza um <input type="color"> (visual) com um campo de texto que
// realmente envia o valor. O picker normaliza para "#rrggbb" (lowercase) e o
// texto aceita hex em qualquer caixa.
export default class extends Controller {
  static targets = ["picker", "text"]

  fromPicker() {
    this.textTarget.value = this.pickerTarget.value
  }

  fromText() {
    const v = this.textTarget.value.trim()
    if (/^#[0-9a-fA-F]{6}$/.test(v)) {
      this.pickerTarget.value = v.toLowerCase()
    }
  }
}
